import { Location } from '@rocksoft/inroom-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { LocationActionsUnion, LocationActionTypes } from './locations.actions';

export const inRoomLocationsFeatureKey = 'inroom-locations';

export type LocationState = EntityState<Location>;

export function selectLocationId(location: Location): string {
  return location.HotelCode;
}

export const adapter: EntityAdapter<Location> = createEntityAdapter<Location>({
  selectId: selectLocationId,
});

export const initialState: LocationState = adapter.getInitialState({});

export function locationReducer(state: LocationState = initialState, action: LocationActionsUnion): LocationState {
  switch (action.type) {
    case LocationActionTypes.LOCATION_API_LOCATION_ADDED:
      return adapter.addOne(action.payload, state);
    case LocationActionTypes.LOCATION_API_LOCATIONS_LOADED:
      return adapter.setAll(action.payload, state);
    case LocationActionTypes.LOCATION_API_LOCATION_DELETED:
      return adapter.removeOne(selectLocationId(action.payload), state);
    case LocationActionTypes.LOCATION_HEADER_LOCATION_DELETED:
      return {
        ...state,
      };
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectLocationIds = selectIds;

export const selectLocationEntities = selectEntities;

export const selectAllLocations = selectAll;

export const selectLocationTotal = selectTotal;
